import Dexie from 'dexie';

import { CoSyncStrategy } from '@/workerProcessRenderer/scripts/CoSyncEngine/common/CoSyncConfig';
import { SyncOperationType } from '@/workerProcessRenderer/scripts/CoSyncEngine/common/SyncOperationItem';
import { SyncTreeNode } from '@/workerProcessRenderer/scripts/CoSyncEngine/Tree/typings';
import { conflictResolveType } from '@/workerProcessRenderer/scripts/CoSyncEngine/common/ConflictData';

export interface SyncHistoryItem {
  id?: number;
  name: string;
  relativePath: string;
  operate: SyncOperationType;
  strategy: CoSyncStrategy;
  originRelativePath: string; // 移动前的路径，包含重命名
  finishTime: number;
  conflictResolveChoose?: conflictResolveType; // 若有冲突解决选择，则该值为选择的值，否则为undefind
  isSkipped?: boolean;
  isDir?: boolean;
}

// export type SyncTreeDAONode = SyncTreeNode & { id?: number };

const coSyncTaskDBMap = new Map<number, Dexie>();

export function getCoSyncTaskDB(localSyncId: number) {
  let dexie!: Dexie;

  if (coSyncTaskDBMap.has(localSyncId)) {
    dexie = coSyncTaskDBMap.get(localSyncId)!;
  } else {
    dexie = new Dexie(`CoSyncTaskDB_${localSyncId}`);
    // TODO: 同步盘真实发布时将此处版本改为1
    dexie.version(5).stores({
      history: '++id, timestamp',
      syncTree: 'path',
    });
    dexie
      .version(6)
      .stores({
        history: '++id, finishTime',
        syncTree: 'path',
      })
      .upgrade(tx => {
        return tx.table('history').clear();
      });
  }

  coSyncTaskDBMap.set(localSyncId, dexie);

  const deleteDB = async () => {
    await dexie.delete();
  };

  return {
    dexie,
    deleteDB,
    history: dexie.table<SyncHistoryItem, number>('history'),
    // syncTree: dexie.table<SyncTreeDAONode, number>('syncTree'), 已隔离
  };
}

export type CoSyncTaskDB = ReturnType<typeof getCoSyncTaskDB>;
